import React from 'react';
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import Home from "./Home";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const App = () => {

  const appVersion = appversion.version;
  const isProduction = process.env.NODE_ENV === "production";
  return (
    <>
    
    <BrowserRouter>
      <CacheBuster
        currentVersion={appVersion}
        isEnabled={isProduction}
        isVerboseMode={false}
        metaFileDirectory={"*"}
      >
          <Routes>
            {/* <Route
              path="realty/:loName"
              element={<Home />}
            /> */}
            <Route path="realty/" element={<Home />} />
          </Routes>
          
      </CacheBuster>
      </BrowserRouter>
      
    </>
  );
};

export default App;
